module.exports = __webpack_public_path__ + "static/media/amex.f62f0a79.png";